import type { Filters } from "@/types";

/** Compact human summary of active filters, e.g. "★≥5 · Python · mit". */
export function filtersSummary(f: Filters | undefined): string {
  if (!f) return "";
  const parts: string[] = [];
  if (f.min_stars) parts.push(`★≥${f.min_stars}`);
  if (f.language) parts.push(f.language);
  if (f.pushed_after) parts.push(`обновлён >${f.pushed_after}`);
  if (f.license) parts.push(f.license);
  if (f.topic) parts.push(`#${f.topic}`);
  return parts.join(" · ");
}
